(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Medication', Medication);

    Medication.$inject = ['$resource'];

    function Medication ($resource) {
        var resourceUrl =  'api/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByPatientId': { 'url': 'api/medications/patient/:id', method: 'GET', isArray: true}
        });
    }
})();
